import { getUserRoleFlags } from "@jugl-web/domain-resources/users/utils/getUserRoleFlags";
import { UserRole } from "@jugl-web/rest-api";
import { useMemo } from "react";
import { useBoardPermissions } from "./useBoardPermissions";

interface UseTaskModulePermissionsOptions {
  entityId: string;
  meId: string | undefined;
  boardId: string | undefined | null;
  userRole: UserRole | undefined;
}

export const useTaskModulePermissions = ({
  entityId,
  meId,
  boardId,
  userRole,
}: UseTaskModulePermissionsOptions) => {
  const userRoleFlags = useMemo(() => getUserRoleFlags(userRole), [userRole]);

  const boardPermissions = useBoardPermissions({
    entityId,
    meId,
    boardId,
  });

  const canCreateTask = useMemo(
    () =>
      !userRoleFlags.hasEmployeeLikeRole &&
      (boardId ? boardPermissions.canCreateTasks : true),
    [userRoleFlags, boardPermissions, boardId]
  );

  return { canCreateTask };
};
